import { DesktopLoginForm } from "../../../apps/desktop-next/src/components/DesktopLoginForm";
import type { AuthPort } from "@orni/domain-typescript";
import { useI18n } from "../../../apps/desktop-next/src/i18n";
import { createElement } from "react";

/** Shared sign-in surface used by Cloud Web and the same-origin Web client. */
export function CloudLogin({ auth }: { auth: AuthPort }) {
  const { t } = useI18n();
  return createElement(
    "main",
    { className: "cloud-auth-page" },
    createElement(
      "section",
      { className: "cloud-auth-panel" },
      createElement(
        "div",
        { className: "cloud-auth-brand" },
        createElement("strong", null, "Orni"),
        createElement("span", null, t("app.product.signInTitle")),
      ),
      createElement("p", null, t("app.product.signInLead")),
      createElement(DesktopLoginForm, { auth, onSuccess: () => undefined }),
    ),
  );
}
